import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

import { APP_ENV, SENTRY_DSN } from '@/utils/constants'
import { scrubData, scrubEvent } from '@/utils/telemetry'

/**
 * Sentry only starts when a DSN is configured, so no build-time flag is needed to
 * disable it. The e2e run sets a dummy DSN and routes its envelopes, so it never sends.
 */
export function initSentry(app: App, router: Router): void {
  if (!SENTRY_DSN) return

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: __APP_VERSION__,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.2,
    sendDefaultPii: false,
    attachProps: false,
    beforeBreadcrumb: scrubData,
    beforeSend: scrubEvent,
    beforeSendTransaction: scrubEvent,
    beforeSendSpan: scrubData,
  })
}

export default initSentry
